import {
  CheckCircleIcon,
  ClockIcon,
  ExclamationTriangleIcon,
  XCircleIcon,
} from "@heroicons/react/16/solid"
import clsx from "clsx"
import type { ReactNode } from "react"

export type BadgeVariant = "neutral" | "info" | "success" | "error" | "warning"

const Badge = ({
  variant,
  size = "md",
  className,
  children,
  hideIcon = false,
}: {
  variant: BadgeVariant
  size?: "sm" | "md"
  className?: string
  children: ReactNode
  hideIcon?: boolean
}) => (
  <div
    className={clsx(
      "-outline-offset-1 flex items-center gap-x-1 whitespace-nowrap font-semibold text-xs/none outline outline-transparent",
      {
        "rounded-md px-1.5 py-[3px]": size === "sm",
        "rounded-lg px-2 py-1.5": size === "md",
        "bg-red-500/15 text-red-700 dark:text-red-400": variant === "error",
        "bg-blue-500/15 text-blue-700 dark:text-blue-300": variant === "info",
        "bg-green-600/15 text-green-800 dark:text-green-500":
          variant === "success",
        "bg-yellow-200/50 text-yellow-800 dark:bg-yellow-500/10 dark:text-yellow-200 dark:outline-yellow-500/10":
          variant === "warning",
        "bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300":
          variant === "neutral",
      },
      className
    )}
  >
    {!hideIcon && variant === "error" && (
      <XCircleIcon className="size-3 text-red-500 dark:text-red-400" />
    )}
    {!hideIcon && variant === "info" && (
      <ClockIcon className="size-3 text-blue-500 dark:text-blue-400" />
    )}
    {!hideIcon && variant === "success" && (
      <CheckCircleIcon className="size-3 text-green-700 dark:text-green-500" />
    )}
    {!hideIcon && variant === "warning" && (
      <ExclamationTriangleIcon className="size-3 text-yellow-600 dark:text-yellow-500" />
    )}
    {children}
  </div>
)

export default Badge
